export default __webpack_public_path__ + "static/Netwealth-cababa5d2d02d43a7e9b3b34cd5c72f3.png";